import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  templateContextList: [],
  templateContextItem: {},
  templateContextLoading: false,
};

const templateContextSlice = createSlice({
  name: 'templateContextSlice',
  initialState,
  reducers: {
    templateContextLoadingSlice: (state, { payload }) => {
      state.templateContextLoading = payload;
    },
    templateContextListSlice: (state, { payload }) => {
      state.templateContextList = payload;
    },
    templateContextItemSlice: (state, { payload }) => {
      state.templateContextItem = payload;
    },
  },
});

const { actions, reducer } = templateContextSlice;

export const {
  templateContextLoadingSlice,
  templateContextListSlice,
  templateContextItemSlice,
} = actions;

export default reducer;
